import { render, staticRenderFns } from "./ServiceTab.vue?vue&type=template&id=162fda9f&scoped=true&"
import script from "./ServiceTab.vue?vue&type=script&lang=js&"
export * from "./ServiceTab.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTab.vue?vue&type=style&index=0&id=162fda9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162fda9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('162fda9f')) {
      api.createRecord('162fda9f', component.options)
    } else {
      api.reload('162fda9f', component.options)
    }
    module.hot.accept("./ServiceTab.vue?vue&type=template&id=162fda9f&scoped=true&", function () {
      api.rerender('162fda9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/Tabs/ServiceTab.vue"
export default component.exports